import { gql } from "@apollo/client";

export const FRAGMENT_SHIPMENT_STATUS_ERROR_PRODUCT_ROW = gql`
  fragment shipmentStatusErrorProductRow on ShipmentStatusErrorProductRowType {
    id
    shipmentInvoiceRow {
      id
      productName
      product {
        id
        images: computedImages(size: "300x300") {
          id
          url
        }
      }
      qty
    }
  }
`;

export const FRAGMENT_SHIPMENT_ERROR = gql`
  fragment shipmentError on ShipmentErrorType {
    id
    notes
    error {
      id
      code: fullCode
      description
      tags {
        id
        name
      }
    }
    shipmentStatusErrorProductRows {
      ...shipmentStatusErrorProductRow
    }
    shipmentStatusErrorFactories {
      id
      factory {
        id
        name
        nickName
      }
    }
    created
    hasDelay
    newEtd
    newEta
    delayDays
  }
  ${FRAGMENT_SHIPMENT_STATUS_ERROR_PRODUCT_ROW}
`;

export const FRAGMENT_SHIPMENT_STATUS = gql`
  fragment shipmentStatus on ShipmentStatusType {
    id
    status
    created
    notes
    errors {
      ...shipmentError
    }
  }
  ${FRAGMENT_SHIPMENT_ERROR}
`;

export const CREATE_SHIPMENT_STATUS = gql`
  mutation CREATE_SHIPMENT_STATUS(
    $shipmentId: ID!
    $status: String
    $notes: String
    $created: TimeStamp
  ) {
    createShipmentStatus(
      shipmentId: $shipmentId
      status: $status
      notes: $notes
      created: $created
    ) {
      shipmentStatus {
        id
        status
        created
        notes
        errors {
          ...shipmentError
        }
      }
      shipment {
        id
        latestStatus
      }
    }
  }
  ${FRAGMENT_SHIPMENT_ERROR}
`;

export const UPDATE_SHIPMENT_STATUS = gql`
  mutation UPDATE_SHIPMENT_STATUS(
    $id: ID!
    $notes: String
    $created: TimeStamp
  ) {
    updateShipmentStatus(id: $id, notes: $notes, created: $created) {
      shipmentStatus {
        id
        notes
        created
      }
    }
  }
`;

export const DELETE_SHIPMENT_STATUS = gql`
  mutation DELETE_SHIPMENT_STATUS($id: ID!) {
    deleteShipmentStatus(id: $id) {
      id
    }
  }
`;

export const CREATE_SHIPMENT_ERROR = gql`
  mutation CREATE_SHIPMENT_ERROR(
    $shipmentStatusId: Int
    $errorId: Int
    $shipmentInvoiceRowIds: [Int]
    $factoryIds: [Int]
    $notes: String
    $created: TimeStamp
    $hasDelay: Boolean
    $newEtd: TimeStamp
    $newEta: TimeStamp
    $delayDays: Int
  ) {
    createShipmentError(
      shipmentStatusId: $shipmentStatusId
      errorId: $errorId
      shipmentInvoiceRowIds: $shipmentInvoiceRowIds
      factoryIds: $factoryIds
      notes: $notes
      created: $created
      hasDelay: $hasDelay
      newEtd: $newEtd
      newEta: $newEta
      delayDays: $delayDays
    ) {
      shipmentError {
        ...shipmentError
      }
      shipment {
        id
        newEtd
        newEta
      }
    }
  }
  ${FRAGMENT_SHIPMENT_ERROR}
`;

export const UPDATE_SHIPMENT_ERROR = gql`
  mutation UPDATE_SHIPMENT_ERROR(
    $id: ID!
    $errorId: ID
    $notes: String
    $created: TimeStamp
    $hasDelay: Boolean
    $newEtd: TimeStamp
    $newEta: TimeStamp
    $delayDays: Int
    $shipmentInvoiceRowIds: [ID]
    $factoryIds: [ID]
  ) {
    updateShipmentError(
      id: $id
      errorId: $errorId
      notes: $notes
      created: $created
      hasDelay: $hasDelay
      newEtd: $newEtd
      newEta: $newEta
      delayDays: $delayDays
      shipmentInvoiceRowIds: $shipmentInvoiceRowIds
      factoryIds: $factoryIds
    ) {
      shipmentError {
        ...shipmentError
      }
      shipment {
        id
        newEtd
        newEta
      }
    }
  }
  ${FRAGMENT_SHIPMENT_ERROR}
`;

export const DELETE_SHIPMENT_ERROR = gql`
  mutation DELETE_SHIPMENT_ERROR($id: ID!) {
    deleteShipmentError(id: $id) {
      id
      shipment {
        id
        newEtd
        newEta
      }
    }
  }
`;

export const FETCH_ALL_ERROR_CATEGORIES = gql`
  query FETCH_ALL_ERROR_CATEGORIES {
    allErrorCategories {
      id
      name
      code
      errors {
        id
        code: fullCode
        description
        tags {
          id
          name
        }
      }
    }
  }
`;
